import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { PRODUCT } from '../data/product';
const symptoms = ['Machine won’t start?', 'Abnormal vibration, overheating or pressure loss?', 'Motor, bearing, hydraulic system, sensor… where do you check first?'];
export function ProblemSection() {
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-139" data-mp="2vpg3a24g4vfi">
      <div className="mx-auto max-w-3xl" data-id="element-140" data-mp="2voob71a25ftz">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-141" data-mp="39gup0gpqnaq9">
          STOP GUESSING WHERE THE PROBLEM STARTS
        </h2>

        <ul className="mt-2 grid gap-1.5 sm:grid-cols-3" data-id="element-142" data-mp="35idf5pexnm55">
          {symptoms.map(symptom => <li key={symptom} className="flex items-start gap-1.5 rounded-md border-l-4 border-volt bg-white p-2 text-[13px] font-semibold leading-snug text-navy shadow-sm" data-id="element-143" data-mp="3jdza0d7ul05h">
              <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0 text-volt" aria-hidden="true" data-id="element-144" data-mp="1k2xygyky0c5b" />
              {symptom}
            </li>)}
        </ul>

        <p className="mt-2 text-center text-[13px] font-medium leading-snug text-carbon/85 sm:text-[15px]" data-id="element-145" data-mp="obye6c4574m3">
          <span className="font-bold text-navy" data-id="element-146" data-mp="sd9wdwkosnk9">{PRODUCT}</span> gives you an
          organized visual troubleshooting system to help you move from symptom
          to possible cause with a clearer diagnostic path.
        </p>
        <p className="mt-1 text-center font-head text-base font-bold uppercase tracking-[0.14em] text-navy sm:text-lg" data-id="element-147" data-mp="122th77rymrhr">
          Observe. Isolate. Diagnose.
        </p>
      </div>
    </section>;
}